import { ProviderService } from "./provider"

export abstract class Service {
    // Nom du service
    name = ""

    // récupèration de l'instance de la class fille
    public static getInstance(): any {}

    /**
     * tableau qui fait correspondre une clef et un pointeur de fonction
     * /!\ ne metter dans ce tableau que les fonction des services que
     * l'on souhaite mettre à disposition aux composant de manière
     * dynamique dans un fichier de config JSON (ex. PageConfig)
     */
    public serviceMap: Array<ServiceMapPair> = []

    /**
     * retourne le pointeur de fonction qui correspond à la clef donnée
     * @param key Clef du pointeur de fonction à récupèrer
     */
    public fromMap(
        key: string
    ): ((...args: any[]) => Promise<any>) | undefined {
        const serviceMapPair: ServiceMapPair | undefined = this.serviceMap.find(
            (pair: ServiceMapPair) => {
                return key === pair.key
            }
        )

        return serviceMapPair?.fct
    }

    /**
     * ajoute un entrée custom dans le tableau de mapping
     * @param pair Paire à modifier / ajouter
     */
    public setMap(pair: ServiceMapPair): void {
        // on récupère l'index du tableau de la cléf donnée en paramètre
        const serviceMapPairIndex: number = this.serviceMap.findIndex(
            (currentPair: ServiceMapPair) => {
                return pair.key === currentPair.key
            }
        )

        // si une clef de ce nom existe déjà on met à jour sinon on push la nouvelle valeur
        if (serviceMapPairIndex > -1) {
            this.serviceMap[serviceMapPairIndex] = pair
        } else {
            this.serviceMap.push(pair)
        }
    }

    public static async getRequestHeaders(): Promise<any> {
        let token = ""
        const store = ProviderService.getInstance().get("StoreService")
        if (store && store.getInstance) {
            token = await store.getInstance().persistant.get("token")
        }

        const header: any = {
            "content-type": "application/json",
        }

        if (token) header.authorization = `Bearer ${token}`

        return header
    }
}

export interface ServiceMapPair {
    key: string
    fct: (...args: any[]) => Promise<any>
}

export interface ServiceRefMapPair {
    key: string
    serviceRef: typeof Service
}
